export enum PageNumberOfItemProps {
  securities = "securitiesPageNumberOfItem",
  issuers = "issuersPageNumberOfItem"
}
